// extracted by mini-css-extract-plugin
export default {"inputField":"styles_inputField__bQuDK","priceSection":"styles_priceSection__kA+0m"};